import { MessagesListResponse, MessageDetails as MessageDetailsIn } from "../../api/RealEstateComplex";
import { Message, MessageDetails } from "../../types/realEstateUnit/RealEstateUnitTypes";
import { toLocaleDate } from "../../util/conversionUtils";

export const mapResponseToView = async (response: MessagesListResponse): Promise<Message[]> => {
  const listOfMsgs = response.resultsList || [];

  const messages = listOfMsgs.map((msg: Message) => {
    const { id, saadetud, vastatud, sisu, kommentaar, vastus } = msg;

    const message: Message = {
      id: id,
      saadetud: toLocaleDate(saadetud),
      sisu: sisu,
      kommentaar: kommentaar,
      vastatud: toLocaleDate(vastatud),
      vastus: vastus,
    };
    return message;
  });

  return messages;
};

export const mapDetailResponseToView = async (response: MessageDetailsIn): Promise<MessageDetails> => {
  const {
    id,
    saadetud,
    saatjaIsikNimi,
    vastatud,
    vastaja,
    vastajaNimi,
    saajaIsikud,
    saatjaIsik,
    sisu,
    vastus,
    teostatud,
    kommentaar,
  } = response;

  const message: MessageDetails = {
    id: id,
    vastaja: vastaja,
    saatjaIsikNimi: saatjaIsikNimi,
    vastajaNimi: vastajaNimi,
    saadetud: toLocaleDate(saadetud),
    vastatud: toLocaleDate(vastatud),
    saajaIsikud: saajaIsikud
      ? saajaIsikud.map((recepient) => {
          return {
            saajaIsikNimi: recepient.saajaIsikNimi,
            saajaIsik: recepient.saajaIsik,
          };
        })
      : [],
    saatjaIsik: saatjaIsik,
    sisu: sisu,
    kommentaar: kommentaar,
    vastus: vastus,
    teostatud,
  };
  return message;
};
